module.exports = __webpack_public_path__ + "img/C&M_White.3690cef9.svg";